import { Observable } from "rxjs";
import { AccountHintData, AccountHintParams } from "./account.model";

export abstract class AccountBaseService {

  abstract queryHints(query: AccountHintParams): Observable<AccountHintData[]>;
}